import { render, staticRenderFns } from "./AssistantUpsertFormDescription.vue?vue&type=template&id=75ff2138"
import script from "./AssistantUpsertFormDescription.vue?vue&type=script&lang=js"
export * from "./AssistantUpsertFormDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports